import React from "react";


class Commons {

 validateFirmaField  (f, fname, errorList, setValid)  {
    var dataFirmaText=f.current.getSaveData();
    var dataFirma = JSON.parse(dataFirmaText);
    //console.log(dataFirma);
    //console.log(dataFirma.lines.length);
    if (dataFirma.lines.length==0) {
        errorList.push(fname);
        setValid(false);
    }
}


validateField  (f, fname, errorList, setValid)  {
    if (f=="" || f==undefined)
       errorList.push(fname);
        setValid(false);
}


getErrorMessageField  (fieldname, errors)  {
    if (errors.includes(fieldname))
        return "Debe completar este campo"; 
    else
        return "";
} 

 getErrorFirmaMessageField  (fieldname, errors)  {
    if (errors.includes(fieldname))
        return "Deberá firmar aquí"; 
    else
        return "";
} 
}
export default new Commons();